<template>
  <svg width="642" height="125" viewBox="0 0 642 125" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M623.032 123.358H257.618C247.711 123.358 239.649 114.208 239.649 102.965C239.649 91.7223 247.711 82.5722 257.618 82.5722H289.009C298.915 82.5722 306.977 73.4221 306.977 62.1791C306.977 50.9362 298.915 41.7861 289.009 41.7861H18.9684C9.06219 41.7861 1 32.636 1 21.393C1 10.1501 9.06219 1 18.9684 1H555.575C565.481 1 573.544 10.1501 573.544 21.393C573.544 32.636 565.481 41.7861 555.575 41.7861H380.266C370.359 41.7861 362.297 50.9362 362.297 62.1791C362.297 73.4221 370.359 82.5722 380.266 82.5722H623.032C632.938 82.5722 641 91.7223 641 102.965C641 114.208 632.938 123.358 623.032 123.358Z" fill="white" stroke="#DBE4FF" stroke-width="2" stroke-miterlimit="10" />
  </svg>
</template>

<style lang="scss" scoped>
svg {
  fill: #fff;
  stroke-width: 2px;
  stroke: #dbe4ff;
}
</style>
